<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    :confirm-text="disabledBtn?'上传视频中':'保存'"
    :title="title"
    width="30%"
    :confirm-disable="disabledBtn"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="100px"
      >
        <el-form-item
          label="上传视频"
          prop="videoUrl"
        >
          <div class="video-upload">
            <upload
              :file-list.sync="createForm.videoUrl"
              type="video"
              @isProcess="getProcess"
            />
            <div />
          </div>
        </el-form-item>
      </el-form>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';
import upload from '@/components/common/upload/upload.vue';

export default {
  name: 'CourseChapter',
  components: { customeDialog, upload },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    videoExamId: {
      type: [Number, null],
      default: null,
    },
  },
  data() {
    return {
      title: '上传视频考试视频',
      cancelText: '取消',
      disabledBtn: false,
      createForm: {
        videoUrl: '',
        videoExamId: null,
      },
      creatRules: {
        videoUrl: [
          { required: true, message: '请上传视频', trigger: 'blur' },
        ],
      },
    };
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.createForm.clearValidate();
          this.createForm.videoUrl = '';
        });
      }
    },
  },
  methods: {
    // 关闭弹窗
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close');
    },
    // 上传过程中
    getProcess(value) {
      this.disabledBtn = value;
    },
    confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          this.createForm.videoExamId = this.videoExamId;
          const data = await axClient.order.uploadVideoExamBackend(this.createForm);
          if (!data) return;
          this.$message.success('上传视频成功');
          this.$emit('update:dialogVisible', false);
          this.$emit('confirm');
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 200px;
  .wx-info {
    padding: 0 0 0 0;
    text-align: left;
    .item {
      margin-bottom: 15px;
      span {
        font-size: 12px;
        color: $--base-color-black;
        &:last-child {
          padding-left: 8px;
        }
      }
    }
  }
}

</style>
